import { get, postWithHeaders } from "../utility/fetch-util";
import { getSessionData } from "../utility/global-util";

/**
 * Check if there is a configured address provider
 */
export const checkLocationServiceAvailable = async (progress) => {
    return get('/api/drivers/location/lookup-enabled', null, progress);
}

/**
 * Use address provider to find address
 */
export const doAddressSearch = async (postcode, params, progress) => {
    return get('/api/drivers/location/' + postcode, params,progress);
}

/**
 * Get the full address details for a result returned by doAddressSearch
 */
export const getAddressfromProvider = async (postcode, providerIdentifier, progress) => {
    return get('/api/drivers/location/' + postcode + '/' + providerIdentifier, null, progress);
}

/**
 * Get list of country codes
 */
export const getCountries = async (progress) => {
    return get('/api/drivers/location/countries', null, progress);
}

/**
 * Get Location types (Configured in IM)
 */
export const getLocationTypes = async (progress) => {
    return get('/api/drivers/location/types', null, progress);
}

/** 
 *  Get the Configured API Key
 */
export const getMapsApiKey = async (progress) => {
    return get('/api/drivers/location/maps-key', null, progress);
}

/**
 * Find places related to the searchtext (Requires google places api (new))
 */
export const autocompleteLocation = async (searchText, progress) => {
    return postWithHeaders('https://places.googleapis.com/v1/places:searchText' , {fields: "places.displayName,places.location,places.shortFormattedAddress,places.name", }, {
        textQuery: searchText, pageSize: 5,
    }, progress, {"X-Goog-Api-Key": getSessionData('REACT_APP_MAPS_KEY')});
}
